import { FetchError } from './FetchError';
import { FETCH_TRANSFORMER_ERROR_CODE } from 'utils';

/**
 * Invalid parameter errors (invalid formats, missing required internal parameters)
 *
 * Used for internal service validation, NOT user input validation.
 * For user input validation, use Zod or similar schema validators.
 *
 * @example
 * ```typescript
 * throw new InvalidParameterError('Invalid PSI endpoint format', {
 *   endpoint: 'invalid.format',
 *   expected: 'service.module.action'
 * });
 * ```
 */
export class InvalidParameterError extends FetchError {
  override readonly type = 'InvalidParameterError';

  constructor(message: string, details?: Record<string, unknown>, cause?: Error) {
    super(message, FETCH_TRANSFORMER_ERROR_CODE.INVALID_PARAMETER_ERROR, undefined, details, cause);
  }
}
